module.exports = __webpack_public_path__ + "img/addsecicon.65372826.svg";